import React, { useState, useEffect } from 'react';
import { Name } from '../../facades/Icon';
import { Icon } from '../../facades';

export interface AsureCloudToast {
  title: string;
  kind: 'error' | 'info' | 'warning' | 'success';
  hideCloseButton?: boolean;
  timeout?: 3 | 5 | 10 | 15 | 30 | 60;
  className?: string;
  hideIcon?: boolean;
  children: React.ReactNode;
  closeDisabled?: boolean;
  titleOnly?: boolean;
  leftBorder?: boolean;
}
export const AsureCloudToast = ({
  kind,
  title,
  hideCloseButton,
  timeout,
  className,
  hideIcon,
  children,
  closeDisabled,
  titleOnly,
  leftBorder
  }: AsureCloudToast) => {
    const IconTypes = {
      error: 'ban',
      success: 'check-circle',
      warning: 'exclamation-circle',
      info: 'info-circle',
    }
    const ToastIcon = IconTypes[kind] as Name;
    const [displayToast, setDisplayToast] = useState(true);
    const showChildren = children && !titleOnly;
    let classList = `d-flex flex-row ac-toast bx--toast-notification ${leftBorder ? 'bx--toast-notification--left-border' : 'bx--toast-notification--low-contrast'} bx--toast-notification--${kind}`;
    classList += className ? ` ${className}` : '';
    
    useEffect(() => {
      if(timeout) {
        const timeoutId = window.setTimeout(() => {
          setDisplayToast(false);
        }, timeout * 1000);
        return () => {
          window.clearTimeout(timeoutId);
        }
      }
    }, [timeout])
    if (displayToast) {
      return (
        <div role="alert" className={classList}>
          <div className="ac-toast-icon">
            { !hideIcon && 
              (
                <Icon
                  className="toast-icon"
                  icon={ToastIcon}
                  lib="fal"
                />
              )
            }
          </div>
          <div className="ac-toast-details">
            <h1>{title}</h1>
            { showChildren && <div className="body-md">{children}</div> }
          </div>
          { !hideCloseButton && 
            (
              <div className="ac-toast-close">
                <div onClick={() => setDisplayToast(false)} className={`${closeDisabled ? 'disabled ' : ''}ac-toast-close-icon d-flex flex-column justify-content-center align-items-center`}>
                  <Icon
                    className="close-icon"
                    icon='times'
                    lib="fal"
                  />
                </div>  
              </div>
            )
          }
        </div>
      )
    }
    return null;
}
export default AsureCloudToast;